import { Stack, useRouter } from 'expo-router';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useAnalyticsConfiguration } from 'shared/hooks/analytics/useAnalyticsConfiguration';
import { usePressableAnalytics } from 'shared/hooks/analytics/usePressableAnalytics';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import {
  ErrorScreen,
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import theme from 'shared/styles/theme';

const FeatureLevelErrorScreen = () => {
  const router = useRouter();
  const { t: translatedText } = useTranslation('personalInfoStrings');
  const { segmentClient } = useAnalyticsConfiguration();

  useViewDidFocusScreenAnalyticsEvent({
    key: 'confirm-address-error',
  });

  useEffect(() => {
    void segmentClient.logEvent('Confirm Address Error Encountered', {
      category: 'profile_settings',
      subcategory: 'mastercard',
      error_name: 'feature_flag_error',
    });
  }, [segmentClient]);

  const closeScreenAnalytics = usePressableAnalytics({
    analyticsId: 'closeScreenAnalytics',
  });

  const { top } = useSafeAreaInsets();
  const goBack = () => {
    closeScreenAnalytics();
    if (router.canGoBack()) {
      router.back();
    } else {
      router.navigate('/');
    }
  };
  return (
    <>
      <Stack.Screen
        options={{
          headerShown: false,
          headerBackVisible: false,
          headerTransparent: false,
          headerBackButtonMenuEnabled: false,
        }}
      />
      <View style={[styles.container, { paddingTop: top }]}>
        <ErrorScreen
          screenType={ErrorScreenType.Error}
          messageHeadline={translatedText('addressTranslations.error.title')}
          messageBody={translatedText('addressTranslations.error.message')}
          primaryButton={{
            title: translatedText('addressTranslations.error.closeButton'),
            onPress: () => goBack(),
          }}
        />
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
    paddingBottom: theme.spacing.l,
    paddingHorizontal: theme.spacing.m,
  },
});

export default FeatureLevelErrorScreen;
